var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimeToggle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 1.2C45.84 1.2 58.8 14.16 58.8 30C58.8 45.84 45.84 58.8 30 58.8C14.16 58.8 1.2 45.84 1.2 30C1.2 14.16 14.16 1.2 30 1.2ZM30 0C13.44 0 0 13.44 0 30C0 46.56 13.44 60 30 60C46.56 60 60 46.56 60 30C60 13.44 46.56 0 30 0ZM30.6 8.4V3.6C30.6 3.24 30.36 3 30 3C29.64 3 29.4 3.24 29.4 3.6V8.4C29.4 8.76 29.64 9 30 9C30.36 9 30.6 8.76 30.6 8.4ZM9 30C9 29.64 8.76 29.4 8.4 29.4H3.6C3.24 29.4 3 29.64 3 30C3 30.36 3.24 30.6 3.6 30.6H8.4C8.76 30.6 9 30.36 9 30ZM57 30C57 29.64 56.76 29.4 56.4 29.4H51.6C51.24 29.4 51 29.64 51 30C51 30.36 51.24 30.6 51.6 30.6H56.4C56.76 30.6 57 30.36 57 30ZM30.6 56.4V51.6C30.6 51.24 30.36 51 30 51C29.64 51 29.4 51.24 29.4 51.6V56.4C29.4 56.76 29.64 57 30 57C30.36 57 30.6 56.76 30.6 56.4Z",
    fill: "#CBC8CD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeToggle);
export default __webpack_public_path__ + "static/media/timeToggle.d49f79d17f15248eb9a6cd8aa0012913.svg";
export { ForwardRef as ReactComponent };